import type { ComponentType, SVGProps } from 'react';

import {
    FacebookLogoMonoIcon,
    InstagramLogoMonoIcon,
    LinkedinLogoMonoIcon,
    YoutubeLogoMonoIcon,
} from '@coop/icons';

import styles from './Footer.module.scss';

type SocialLogoIcon = ComponentType<SVGProps<SVGSVGElement>>;

const FooterSocial = () => {
    const socialLinks: Array<{ url: string; icon: SocialLogoIcon; label: string }> = [
        {
            url: 'https://www.facebook.com/CoopSverige/',
            icon: FacebookLogoMonoIcon,
            label: 'Coop Sverige Facebook',
        },
        {
            url: 'https://www.instagram.com/coopsverige/',
            icon: InstagramLogoMonoIcon,
            label: 'Coop Sverige Instagram',
        },
        {
            url: 'https://www.youtube.com/user/CoopSverige',
            icon: YoutubeLogoMonoIcon,
            label: 'Coop Sverige YouTube',
        },
        {
            url: 'https://www.linkedin.com/company/coopsverige',
            icon: LinkedinLogoMonoIcon,
            label: 'Coop Sverige LinkedIn',
        },
    ];

    return (
        <div className={styles.FooterSocial}>
            {socialLinks.map((link) => {
                const SocialIcon = link.icon;

                return (
                    <div key={link.label} className={styles.FooterSocialItem}>
                        <a
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={link.label}
                        >
                            <SocialIcon
                                width="20"
                                height="20"
                                className={styles.FooterSocialIcon}
                                aria-hidden
                            />
                        </a>
                    </div>
                );
            })}
        </div>
    );
};

export default FooterSocial;
